import { NgModule, Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ResizableModule } from 'angular-resizable-element';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import {MatTabsModule} from '@angular/material/tabs';
import { Subscription } from 'rxjs';
import { ChatBasicModule } from './chat.basic';
import { ChanceTalkListModule } from './chancetalk-list';
import { ChanceTalkViewModule } from './chancetalk-view';
import { ConnFriendsModule } from './connector-friends';

import { ChatRoomListModule } from './chatroom';
import { ChatRoomViewModule } from './chatroom-view';

import { SocketService } from '../../services/socket.service';
import { EventService } from '../../services/event.service';
import { ToasterService } from '../../services/toaster.service';
import { HttpService } from '../../services/http.service';
@Component({
    selector: 'mini-chat-box',
    template: `
        <div class="chat_top">
            <div class="chat-window-layout">

                <div mwlResizable (resizeStart)="onResizeStart()" (resizing)="onResizing($event)" (resizeEnd)="onResizeEnd()"
                    [resizeEdges]="{bottom: false, right: false, top: true, left: false}"><!--  [ngStyle]="{height: (resizeDynamicHeight) + 'px'}" -->
                    <div class="chat_area">
                        <div class="rg-top">
                            <div mwlResizeHandle  [resizeEdges]="{top: true, bottom: false}"><span></span></div>
                            <a (click)="minichatActivateClose()" class="close"><mat-icon svgIcon="close" aria-label="close"></mat-icon></a>
                        </div>
                        <!-- chat-top -->
                        <mat-tab-group layout-fill (selectedIndexChange)="minichatActivate($event)" [selectedIndex]='selectedChatIndex'>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <span>공개채팅방</span>
                                </ng-template>
                                <chat-room-basic [resizeObject]="resizeObject" [selectedChatIndex]='selectedChatIndex' *ngIf="selectedChat === 'public'"></chat-room-basic>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <span>찬스톡</span>
                                </ng-template>
                                <chance-talk-view [resizeObject]="resizeObject" [selectedChatIndex]='selectedChatIndex' *ngIf="selectedChat === 'chancetalkView'"
                                style="background-color: blue;"
                                    [chancetalkView]="ObjChancetalkView">
                                </chance-talk-view>
                                <chance-talk-list [resizeObject]="resizeObject" [selectedChatIndex]='selectedChatIndex' *ngIf="selectedChat === 'chancetalk'"
                                style="background-color: red;">
                                </chance-talk-list>

                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <span>친구</span>
                                </ng-template>
                                <connector-friends-list [resizeObject]="resizeObject" [selectedChatIndex]='selectedChatIndex' *ngIf="selectedChat === 'connector'"></connector-friends-list>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <span>채팅방</span>
                                </ng-template>
                                <chat-room-list [resizeObject]="resizeObject" [selectedChatIndex]='selectedChatIndex' *ngIf="selectedChat === 'chatroom'"></chat-room-list>
                                <chat-room-view [resizeObject]="resizeObject"
                                    [chatroomView]="ObjChatroomView" *ngIf="selectedChat === 'chatroomView'"></chat-room-view>
                            </mat-tab>
                        </mat-tab-group>
                    </div>
                <!-- // 채팅창 -->
                </div><!-- .resizable -->
            </div><!--. container1 -->
        </div>
    `,
})
export class ChatTabsComponent implements OnDestroy {
  // showNum = 0;
    resizeObject: any = {};

//    resizeDynamicHeight: number = 100;
// {roomId: roomId, chatId: chatId}
    selectedChatIndex = 0;
    selectedChat = 'public'; // public : 공개채팅, chancetalk: 찬스톡리스트, chancetalkView: 찬스톡 상세보기, connector : 친구, chatroom : 채팅방리스트, chatroomView 채팅방상세보기
    ObjChancetalkView: any; // 찬스톡 상세 페이지에 전달할 인자값
    ObjChatroomView: any; // 채팅룸 상세 페이지에 전달할 인자값
    private subscription: Subscription; // 채팅창 관련 다양한 이벤트를 이곳에서 받는다.
    @Input() set chatFlag(chatData: any) {
        if (!chatData) {
            return;
        }
        if (chatData.type === 'chanceTalkView') {
            this.openChanceTalkView(chatData);
        }
    }

    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(protected eventService: EventService,
                private socketService: SocketService,
                private http: HttpService,
                protected toasterService: ToasterService ) {
        // this.showNum = this.injector.get('showNum');
        this.subscribe();
    }



    onResizeStart(): void {}
    onResizing(event: any): void {
        this.resizeObject = event;
    }
    onResizeEnd(): void {}

    minichatActivate(i: number) {
        this.selectedChatIndex = i;
        // console.log(e);
        // 이곳에서 모든 리스너를 제어해야 정상적으로 동작한다.

        switch (i) {
            case 0: // @basic1 공개채팅
                this.selectedChat = 'public';
                break;
            case 1: // @chancetalk 찬스톡리스트
                this.selectedChat = 'chancetalk';
                break;
            case 2: // @connector 친구
                this.selectedChat = 'connector';
                break;
            case 3: // @chatroom 채팅방리스트
                this.selectedChat = 'chatroom';
                break;
        }
    }

    minichatActivateClose() {
        this.close.emit(true);
    }

    // event subscription start


    subscribe() {
        this.subscription = this.eventService.subscribe('chancetalk', (obj) => {
            if (obj.type === 'chanceTalkView') {

                if (obj.view_mode === 'preview') {
                    this.openChanceTalkView(obj);
                } else { // 대화 가능한지 여부 체크
                    this.http.post({url: 'chat/before-enter-chancetalk', params: {chancetalk_room_id: obj.chat_id}}).then((rtnObj) => {
                        if (rtnObj.result) {
                            this.openChanceTalkView(obj);
                        } else {
                            this.toasterService.showToaster('error', rtnObj.message);
                        }
                    });
                }
                // this.selectedChat = 'chancetalkView';
            //    this.ObjChancetalkView = obj // {type: 'chanceTalkView',chat_id: chat_id, view_mode: 'preview'}) // viw_mode : direct (바로 넘어오는 경우)

                // 창이 닫혀 있는 경우에 이것이 안됨 따라서 이 부분은 footer.ts에서 처리하여야 함
                // if (typeof obj.view_mode !== 'undefined' && obj.view_mode === 'direct') { // 외부에서 찬스톡으로 바로 넘어온 경우
                //    this.selectedChatIndex = 1;
                //    this.close.emit(false);
            //    }

        } else if (obj.type === 'chatroomView') {
                this.selectedChat = 'chatroomView';
                this.ObjChatroomView = obj; // { type: 'chatroomView',room_id: roomid};
            } else { //  selectedChat: string = '' // public : , : , : 찬스톡 상세보기,  : ,  : , chatroomView 채팅방상세보기

            }
        });
    }

    /**
     * 직접 접근했을 경우
     */
    private openChanceTalkView(obj: any) {
        this.selectedChatIndex = 1;
        this.selectedChat = 'chancetalkView';
        this.ObjChancetalkView = obj; // {    type: 'chanceTalkView',chat_id: chat_id, view_mode: 'preview'}) // viw_mode : direct (바로 넘어오는 경우)

    }

    ngOnDestroy() { // 이곳에서는 채팅과 관련된 모든 사항을 종료시키다.
        this.subscription.unsubscribe();

        // sockent 관련 모든 리스터 삭제
        this.socketService.removeListener('publicChat'); // 공개채팅방과 연결된 리스너 삭제
        this.socketService.removeListener('chanceTalkView'); // 찬스톡 상세보기 관련 리스너 삭제
    }
}

@NgModule({
    declarations: [
        ChatTabsComponent
    ],
    imports: [
        CommonModule,
        ResizableModule,
        MatIconModule,
        MatTabsModule,
        ChatBasicModule,
        ChanceTalkListModule,
        ChanceTalkViewModule,
        ConnFriendsModule,
        ChatRoomListModule,
        ChatRoomViewModule
    ],
    exports: [ ChatTabsComponent ]
})

export class ChatTabsModule {}
